import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const n = ({
  title: l,
  titleId: o,
  ...r
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M312.962 427.94h390.763c38.101 0 57.088-46.123 30.08-72.939L538.392 160.974c-16.619-16.512-43.477-16.512-60.117 0L282.883 355.001c-27.029 26.816-8 72.939 30.08 72.939zm394.293 145.835H316.471c-38.101 0-57.088 46.101-30.08 72.939l195.413 194.005c16.619 16.512 43.477 16.512 60.117 0l195.392-194.005c27.029-26.837 8.021-72.939-30.059-72.939z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s = i(n);
export {
  s as default
};
